import { blackColors, successColor } from 'assets/jss/material-dashboard-pro-react';

const filesStyle = () => ({
	container: {
		textAlign: 'center',
	},
	file: {
		flex: 1,
		margin: '24px 0',
	},
	img: {
		borderRadius: 4,
		boxShadow: `0 8px 12px -6px ${blackColors[3]}`,
	},
	uploadItem: {
		display: 'flex',
		alignItems: 'center',
	},
	upload: {
		width: 'calc(100% - 42px)',
		display: 'inline-block',
		position: 'relative',
	},
	filesContainer: {
		padding: '24px 10%',
	},
	filesTitleWrapper: {
		textAlign: 'center',
		paddingBottom: 24,
	},
	deleteIcon: {
		position: 'absolute',
		right: 12,
		top: 0,
	},
	success: {
		color: successColor[0],
		marginRight: 8,
	},
	fileNameContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	filename: {
		margin: 0,
	},
	successIcon: {
		width: 80,
		height: 80,
	},
	karokieWrapper: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: 40,
	},
	karokie: {
		margin: 'auto',
		width: '270px',
		height: '320px',
		maxWidth: '100%',
	},
});

export default filesStyle;
